import styles from './ViewTour.module.css';
import Panorama from './../panorama/Panorama';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { useAppStore } from '../../hooks/store/useAppStore';
import { activeSceneSelector, createTourInfoSelector, getTourSelector } from '../../hooks/store/getters';
import { resetTourSelector, setTourActiveSceneIndexSelector, setTourObjSelector } from '../../hooks/store/setters';
import { useEffect } from 'react';
import Header from './../../components/common/header/Header';
import Button from 'react-bootstrap/Button';
import ViewTourInfo from './view-tour-info/ViewTourInfo';
import { useState } from 'react';
import ViewHotspotModal from '../../components/view-hotspot-modal/ViewHotspotModal';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { getTour } from '../../services/TourService';
import { setLoaderSelector } from '../../hooks/store/setters';
import { setAlertMessageSelector } from '../../hooks/store/setters';
import { createTourSelector } from '../../hooks/store/getters';
import { BsVolumeUp } from "react-icons/bs";
import { setScenePauseAudioSelector } from '../../hooks/store/setters';
import { pauseSceneAudioSelector } from '../../hooks/store/getters';
import { BsFillVolumeMuteFill } from "react-icons/bs";
import { useQuery } from './../../hooks/useQuery';

const ViewTour = () => {
    
    const query = useQuery();
    
    const { id } = useParams();
    const tourId = useMemo(() => id, [id]);
    
    const tour = useAppStore(getTourSelector(tourId));
    const setTourObj = useAppStore(setTourObjSelector);
    const setTourActiveSceneIndex = useAppStore(setTourActiveSceneIndexSelector);
    const resetTour = useAppStore(resetTourSelector);
    const activeScene = useAppStore(activeSceneSelector);
    const tourInfo = useAppStore(createTourInfoSelector);
    const tourActiveSceneIndex = useAppStore(state => state.tourActiveSceneIndex);
    const setLoader = useAppStore(setLoaderSelector);
    const setAlertMessage = useAppStore(setAlertMessageSelector);
    const currentTour = useAppStore(createTourSelector);
    const setScenePauseAudio = useAppStore(setScenePauseAudioSelector);
    const pauseSceneAudio = useAppStore(pauseSceneAudioSelector);
    
    const [showTourInfo, setShowTourInfo] = useState(query.get('welcome') ? false : true);
    
    
    useEffect(() => {
        setScenePauseAudio(false);
        if (tour) {
            setTourObj(tour);
        } else {

            const getTourObj = async (id) => {
                setLoader("Loading....");   
                try {       
                    const tour = await getTour(id);
                    setTourObj(tour); 
                    console.log('current tour',tour);
                    setLoader("");  
                } catch (error) {
                    console.log('error',error);
                    setAlertMessage("Error while loading tour");
                } 
            }
                      
            getTourObj(id);
        }
        // eslint-disable-next-line
    }, [tour, setTourObj, id]);
    
    useEffect(() => {
        setTourActiveSceneIndex(0);
    }, [currentTour, setTourActiveSceneIndex])
    
    
    useEffect(() => {
        return () => {
          resetTour();
          setTourActiveSceneIndex(null);
        }; 
        // eslint-disable-next-line   
    }, []);
    
    const setActiveScene = sceneIndex => setTourActiveSceneIndex(sceneIndex);
    
    const hideTourInfo = () => setShowTourInfo(false);

    const handleSceneAudio = () => {
        if(!pauseSceneAudio) {
            setScenePauseAudio(true);
        } else {
            setScenePauseAudio(false);
        }
    }

    
    if (!currentTour) {
        console.log('no current tour');
        setLoader("Loading....");   
    } 
    
    
    return (
        <>
        { currentTour && (
            
        <div className="viewTour">
            
            <Header 
                viewMode={true} 
                rightContent={<div id="VR_Enabler"></div>}
            >
                <div className="viewTourMenu">
                    <Button variant="outline-info" className={styles.menuBtn}
                        onClick={() => setShowTourInfo(true)}
                        active={showTourInfo}
                    >
                        Info
                    </Button>
                    <div className={styles.viewScenesBtn}>
                    {
                        currentTour.scenes.map((s, idx) => (
                            <Button key={idx}
                                variant="outline-info" 
                                className={styles.menuBtn}
                                onClick={() => setActiveScene(idx)}
                                active={!showTourInfo && parseInt(tourActiveSceneIndex) === parseInt(idx)}
                            >
                                { s.name }
                            </Button>
                        ))
                        
                    }
                    <div>
                        { !pauseSceneAudio  &&
                            <>
                                <Button variant="light" onClick={handleSceneAudio}>
                                    <BsVolumeUp ></BsVolumeUp>
                                </Button>
                            </>
                        }
                        { pauseSceneAudio &&
                            <>
                                <Button variant="light" onClick={handleSceneAudio}>
                                    <BsFillVolumeMuteFill ></BsFillVolumeMuteFill>
                                </Button>
                            </>
                        }
                    </div>
                    </div>
                    <DropdownButton 
                        className={styles.scenesDropdown} 
                        title="Scenes"
                        variant="plain"
                    >
                        {
                            currentTour.scenes.map((s, idx) => (
                                <Dropdown.Item onClick={() => setActiveScene(idx)}>
                                    { s.name }
                                </Dropdown.Item>
                            ))
                        }
                    </DropdownButton>
                </div>
            </Header>
            
            <ViewTourInfo 
                show={showTourInfo}
                handleClose={hideTourInfo}
                tourInfo={tourInfo}
            />
            
            { 
                activeScene && <div className={styles.viewPanorama}>
                    <Panorama viewMode={true} />
                </div>
            }
            
            { 
                activeScene && <ViewHotspotModal />
            }
             
        </div>
       )}
        </>
    );
    
        
};

export default ViewTour;